module.exports = __webpack_public_path__ + "img/enddump_rig.e4917bd0.jpg";